import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetWageSupplementTranslationTypes,
  GetWageSupplementTranslations,
  SaveWageSupplementTranslations
};

function GetWageSupplementTranslationTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/enumlist/wagesupplementtranslationtypes`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWageSupplementTranslations(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/wageSupplementtranslation`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function SaveWageSupplementTranslations(
  wageSupplementTypeConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/wageSupplementtranslation`,
      wageSupplementTypeConfigurationObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}
